import {
  ApiClientError,
  api_client,
  type ApiResult,
} from "@/api/api_client";

export interface LoginRequest {
  username: string;
  password: string;
  remember_me: boolean;
}

export interface LoginData {
  user_id: number;
  username: string;
  category: string | null;
  default_lang: string | null;
}

export interface LoginExtras {
  token: string;
  token_expires: string;
  is_initial_password: boolean;
  redirect_url: string;
}

export interface LoginResult {
  user: LoginData;
  is_initial_password: boolean;
  message: string;
}

export interface LoginBranding {
  company_name: string;
}

export async function get_login_branding(): Promise<LoginBranding> {
  const result = await api_client.get<LoginBranding>(
    "/api/web/login-branding",
  );

  if (!result.data || typeof result.data.company_name !== "string") {
    throw new ApiClientError("登录页品牌响应格式不正确", "protocol");
  }

  return {
    company_name: result.data.company_name.trim(),
  };
}

export async function login_user(input: LoginRequest): Promise<LoginResult> {
  const result = await api_client.post<LoginData, LoginExtras>(
    "/api/user_login/login",
    input,
  );

  if (!result.data || !result.extras) {
    throw new ApiClientError("登录响应缺少用户信息", "protocol");
  }

  return {
    user: result.data,
    is_initial_password: result.extras.is_initial_password,
    message: result.msg,
  };
}

export async function logout_user(): Promise<ApiResult<undefined, never>> {
  return api_client.get<undefined, never>("/api/user_login/logout");
}
